<template>
  <div class="row">
    <div class="col px-0">
      <v-select
        id="selected_media"
        v-model="selectedMedia"
        data-test="selected_media"
        :options="media"
        label="title"
        :placeholder="$t('network.networkForm.selectExistingMedia')"
        :filterable="false"
        :multiple="allowMultiple"
        @input="$emit('media-selected', selectedMedia)"
        @search="searchMedia"
      >
      <template v-slot:option="option">
        {{ option.title }}
      </template>
      <template v-slot:no-options>
        <span v-if="busy" class="text-center">
          <i class="fas fa-2x fa-spinner mt-2"></i>
        </span>
        <span v-else>
          <span v-if="selectedMedia.length == 0 || selectedMedia == ''">{{ $t('sorry-there-are-no-matching-options') }}</span>
          <span v-else>Select media to add to this collection</span>
        </span>
      </template>
    </v-select>
    </div>
  </div>
</template>
<script>
import { debounce, orderBy } from 'lodash';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    vSelect,
  },
  props: {
    networks: {
      type: Array,
      default: null,
    },
    allowMultiple: {
      type: Boolean,
      default: false,
    },
    existingMedia: {
      type: Array,
      default: null,
    },
    videoOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      media: [],
      selectedMedia: this.existingMedia ? this.existingMedia : null,
      managedNetworks: null,
    };
  },
  mounted() {
    this.$store.dispatch('loadManagedNetworks').then(networks => {
      this.managedNetworks = networks;
    });
  },
  methods: {
    searchMedia: debounce(function (searchQuery) {
      this.busy = true;
      if (searchQuery.length === 0) {
        return;
      }
      if (this.selectedMedia && this.selectedMedia.length > 0) {
        this.existingMedia.splice(0);

        let params = {
          query: searchQuery,
          media_type: this.videoOnly ? 'video' : 'media',
          for_selector: true,
          network_id: this.managedNetworks.map(n => n.id).toString(),
        };
        this.$http.get('networks/feed', { params }).then(resp => {
          this.media.splice(0);
          const sortedResults = orderBy(resp.data.results, 'title');

          sortedResults.forEach(m1 => {
            let mediaExistsInCollection = this.existingMedia.find(m2 => m1.slug === m2.slug);
            if (!mediaExistsInCollection) {
              this.media.push(m1);
            }
          });
          this.busy = false;
        });
      } else {
        let params = {
          limit: this.videoOnly ? 1 : 5,
          query: searchQuery,
          media_type: this.videoOnly ? 'video' : ['video', 'file'],
          for_selector: true,
        };

        if (this.networks) {
          params.network_id = this.networks.map(n => n.id).toString();
        }

        this.$http.get('networks/feed', { params }).then(resp => {
          this.media.splice(0);
          const sortedMedia = orderBy(resp.data.results, 'title');

          sortedMedia.forEach(m => this.media.push(m));
          if (sortedMedia.length === 0) {
            this.busy = false;
          }
        });
      }
    }, 600),
  },
};
</script>
